import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsDurationByDateQuery } from "../graphql/queries";
import type {
  AnalyticsDurationByDateQueryType,
  AnalyticsDurationByDateQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsDurationByDateQuery = (
  options?: QueryHookOptions<
    AnalyticsDurationByDateQueryType,
    AnalyticsDurationByDateQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsDurationByDateQueryType,
    AnalyticsDurationByDateQueryVariablesType
  >(AnalyticsDurationByDateQuery, options);
};
